/**
 * Schnelle erste Anzeige (Google PageSpeed / LCP, 28.10.2026)
 *
 * deploy/prerender_heads.js legt je öffentlicher Seite eine fertig gebaute Fassung in <div id="snap"> ab.
 * Der Browser zeigt sie sofort, während React unsichtbar in #root aufbaut. Sobald die App fertig ist
 * (keine offenen Anfragen mehr, Einblendungen abgeschlossen), wird ohne sichtbaren Sprung umgeschaltet.
 * Abschalten je Gerät: localStorage pb24_snap = "0" bzw. ?snap=0.
 */
const MIN_MS = 400;    // kurze Einblend-Animationen der App laufen unsichtbar an
const QUIET_MS = 150;  // so lange keine offene Anfrage
const MAX_MS = 6000;   // spätestens dann umschalten

let inflight = 0;
let lastActivity = 0;

function trackRequests() {
  const touch = () => { lastActivity = performance.now(); };
  const origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function trackedFetch(...args) {
      inflight += 1; touch();
      return origFetch.apply(this, args).finally(() => { inflight -= 1; touch(); });
    };
  }
  const origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function trackedSend(...args) {
    inflight += 1; touch();
    this.addEventListener("loadend", () => { inflight -= 1; touch(); }, { once: true });
    return origSend.apply(this, args);
  };
}

function enabled() {
  try {
    const q = new URLSearchParams(window.location.search).get("snap");
    if (q === "0" || q === "1") localStorage.setItem("pb24_snap", q);
    return localStorage.getItem("pb24_snap") !== "0";
  } catch {
    return false;
  }
}

export function prepareSnapshot() {
  const snap = document.getElementById("snap");
  const root = document.getElementById("root");
  if (!snap || !root) return;
  if (!snap.firstElementChild || !enabled()) { snap.remove(); return; }

  window.__SNAP_ACTIVE = true;
  root.style.cssText = "position:fixed;inset:0;overflow:hidden;visibility:hidden;pointer-events:none;z-index:-1";
  trackRequests();
  const start = performance.now();
  lastActivity = start;

  const swap = () => {
    const y = window.scrollY;
    snap.remove();
    root.style.cssText = "";
    window.__SNAP_ACTIVE = false;
    window.scrollTo(0, y);
  };
  const tick = () => {
    const now = performance.now();
    const ready = now - start >= MIN_MS && inflight <= 0 && now - lastActivity >= QUIET_MS && root.firstElementChild;
    if (ready || now - start >= MAX_MS) swap();
    else setTimeout(tick, 50);
  };
  setTimeout(tick, MIN_MS);
}
